import { OrmCatalog } from "@natiwi/core/models/catalog";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatObjectController } from "@natiwi/core/controllers/object.controller";

export abstract class NatCatalogController<Model extends OrmCatalog> extends NatObjectController<Model>{

    constructor(_repository: NatCatalogRepository<Model>) {
        super(_repository);
    }
}